import { render, staticRenderFns } from "./GrupBazli.vue?vue&type=template&id=4c7f9980"
import script from "./GrupBazli.vue?vue&type=script&lang=js"
export * from "./GrupBazli.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports